import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'sort-dropdown',
  template: require('./sort-dropdown.component.html'),
  styles: [require('./sort-dropdown.component.css')]
})
export class SortDropdownComponent {
  @Input() columnName: string = '';
  @Output() sortChange = new EventEmitter<{ column: string, order: string }>();

  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOrder(order: string) {
    this.sortChange.emit({ column: this.columnName, order });
    this.isOpen = false; // close dropdown after selection
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.sort-dropdown')) {
      this.isOpen = false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sort-dropdown/sort-dropdown.component.ts